<ol
  class="rec-stepper"
  role="list"
  aria-label="Recording workflow progress"
>
  @for (step of steps(); track step.id; let i = $index) {
    <li
      class="rec-stepper__step"
      [attr.data-state]="stateOf(i)"
      [attr.data-step]="step.id"
      [attr.aria-current]="stateOf(i) === 'active' ? 'step' : null"
      [attr.title]="showSetupTooltip(i) ? 'Complete Recording Setup first' : null"
    >
      <span class="rec-stepper__bullet" aria-hidden="true">
        @if (step.id === 'setup') {
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
        } @else if (step.id === 'review') {
          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
            <polygon points="5 3 19 12 5 21 5 3"/>
          </svg>
        } @else {
          <svg width="8" height="8" viewBox="0 0 8 8">
            <circle cx="4" cy="4" r="4" fill="currentColor"/>
          </svg>
        }
      </span>
      <span class="rec-stepper__label">{{ step.label }}</span>
    </li>
    @if (i < steps().length - 1) {
      <li
        class="rec-stepper__sep"
        [attr.data-filled]="i < currentIndex() ? 'true' : null"
        aria-hidden="true"
      ></li>
    }
  }
</ol>
